import api from '../api';
import {
  IHolidayListResponse,
  IHolidayDetailResponse,
  IHolidayListParams,
  ICreateHolidayPayload,
  ICreateHolidayResponse,
  IUpdateHolidayPayload,
  IUpdateHolidayResponse,
} from '../../interface/holiday.interface';

export const fetchHolidays = async (params: IHolidayListParams) => {
  const res = await api.get<IHolidayListResponse>('/holiday', { params });
  return res.data;
};

export const fetchHolidayById = async (id: string) => {
  const res = await api.get<IHolidayDetailResponse>(`/holiday/${id}`);
  return res.data;
};

export const createHoliday = async (payload: ICreateHolidayPayload) => {
  const res = await api.post<ICreateHolidayResponse>('/holiday', payload);
  return res.data;
};

export const updateHoliday = async (id: string, payload: IUpdateHolidayPayload) => {
  const res = await api.patch<IUpdateHolidayResponse>(`/holiday/${id}`, payload);
  return res.data;
};

export const deleteHoliday = async (id: string) => {
  const res = await api.delete(`/holiday/${id}`);
  return res.data;
};

const holidayService = {
  fetchHolidays,
  fetchHolidayById,
  createHoliday,
  updateHoliday,
  deleteHoliday,
};

export default holidayService;
